import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=10f728a2&scoped=true"
import script from "./volunteer.vue?vue&type=script&lang=js"
export * from "./volunteer.vue?vue&type=script&lang=js"
import style0 from "./volunteer.vue?vue&type=style&index=0&id=10f728a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f728a2",
  null
  
)

export default component.exports